/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Producers_FoundInputs */

const en_no_producers_found = /** @type {(inputs: No_Producers_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No producers found.`)
};

const es_no_producers_found = /** @type {(inputs: No_Producers_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron productores.`)
};

/**
* | output |
* | --- |
* | "No producers found." |
*
* @param {No_Producers_FoundInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const no_producers_found = /** @type {((inputs?: No_Producers_FoundInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Producers_FoundInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_producers_found(inputs)
	return es_no_producers_found(inputs)
});